import { CityOption } from './city';
import { OptionType } from './common';

export enum PreferredDegreeBackgroundEnum {
  None = 'education_none',
  Doctor = 'education_doctor',
  Master = 'education_master',
  Bachelor = 'education_bachelor',
  College = 'education_college',
  NoPreference = 'education_none',
}

export enum PreferredWorkExperienceEnum {
  None = 'work_experience_none',
  LessThanOne = 'work_experience_0',
  OneToThree = 'work_experience_1_3',
  ThreeToFive = 'work_experience_3_5',
  FiveToTen = 'work_experience_5_10',
  MoreThanTen = 'work_experience_10_plus',
}

export type SimplifyJobDetailType = {
  company: {
    logo: null | string;
    industry?: OptionType;
    size: string | null;
    description: string | null;
  } & OptionType;
  salary: string;
  location: string | CityOption | null;
  education: string;
  experience: string;
  description: string;
  position: string;
  qualification: string;
} & OptionType;

export type JobDetailType = SimplifyJobDetailType & {
  job_title: OptionType | null;
  encrypted_url: string | null;
  source_type: string;
  seo_content: Record<string, any> | null;
  email: string | null;
  company_job_opportunities: SimplifyJobDetailType[] | null;
  recommended_job_opportunities: SimplifyJobDetailType[];
};

export type GroupedHotJobsType = [
  {
    jobs: SimplifyJobDetailType[];
  } & OptionType,
];
